
import request from '@/utils/request';
import Vue from 'vue';
//获取大洲列表 
export function continentQuery (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/continent/query`,
      data:params
    });
  }
//创建大洲 
export function continentCreate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/continent/create`,
      data:params
    });
  }
//上移
export function continentMoveUp (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/continent/moveUp/${params}`
    });
  }
//下移
export function continentMoveDown (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/continent/moveDown/${params}`
    });
  }
// 修改
export function continentUpdate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/continent/update`,
      data:params
    });
  }
// 删除 
export function deleteContinent (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/continent/deleteContinent/${params}`
    });
  }
//查询所有的大洲列表 
export function getAllContinent () {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/continent/getAllContinent`
  });
}